export const sortNumsAsc = (a, b) => a - b;

export const sortNumsDesc = (a, b) => b - a;

export const sortAlphaAsc = (a, b) => {
  const val1 = a && a.toLowerCase();
  const val2 = b && b.toLowerCase();
  return val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
};

export const sortAlphaDesc = (a, b) => {
  const val1 = a && a.toLowerCase();
  const val2 = b && b.toLowerCase();
  return val2 < val1 ? -1 : val2 > val1 ? 1 : 0;
};
